import { ref, onMounted, onUnmounted } from "vue";

export function useDeviceType() {
  const isMobile = ref(window.innerWidth <= 1024);

  function checkWidth() {
    isMobile.value = window.innerWidth <= 1024;
  }

  onMounted(() => {
    window.addEventListener("resize", checkWidth);
    checkWidth();
  });

  onUnmounted(() => {
    window.removeEventListener("resize", checkWidth);
  });

  return { isMobile };
}
